// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-header {
  margin: 10px;
  padding: 10px;
  border: 1px solid var(--border-color);
}
.filter-header ::ng-deep .dx-box-item {
  align-items: center;
}
.filter-header ::ng-deep .dx-last-row {
  align-items: center !important;
}

.group-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/view/admin/filter-patient/filter-patient.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,qCAAA;AACJ;AACI;EACI,mBAAA;AACR;AAEI;EACI,8BAAA;AAAR;;AAKA;EACI,WAAA;EACA,iBAAA;EACA,eAAA;AAFJ","sourcesContent":[".filter-header {\n    margin: 10px;\n    padding: 10px;\n    border: 1px solid var(--border-color);\n\n    ::ng-deep .dx-box-item {\n        align-items: center;\n    }\n\n    ::ng-deep .dx-last-row {\n        align-items: center !important;\n    }\n\n}\n\n.group-header {\n    width: 100%;\n    font-weight: bold;\n    font-size: 15px;\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
